import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "about" }
const _hoisted_2 = {
  class: "section about1",
  style: {"background-image":"url(statics/ll/img/about1.jpg)"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-none d-md-block" }, null, -1)
const _hoisted_6 = { class: "col-md-5" }
const _hoisted_7 = { class: "title text-right" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "primary d-inline-block ml-3" }
const _hoisted_10 = {
  class: "detail",
  style: {"font-size":"18px","text-align":"left"}
}
const _hoisted_11 = {
  class: "section about2",
  style: {"background-image":"url(statics/ll/img/about2.jpg)"}
}
const _hoisted_12 = { class: "container text-center" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "detail" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-none d-md-block" }, null, -1)
const _hoisted_18 = {
  class: "section about3",
  style: {"background-image":"url(statics/ll/img/about3.jpg)"}
}
const _hoisted_19 = { class: "container text-center" }
const _hoisted_20 = { class: "row align-items-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-none d-md-block" }, null, -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "info" }
const _hoisted_25 = { class: "detail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.show?"Dehaa Rossun":"About"), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.show?"研究中心":"Dehaa Rossun"), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.show?' Dehaa Rossun'+
              '研究中心是一个多机构，多学科的研究中心。其研究领域包括营养学、病理学、护理学、行为学、心理学等。针对现代家庭健康状况，开展前瞻性、预测性研究，并在各个领域为家庭健康提供全方位解决方案。'
             +' Dehaa'+
             ' Rossun积极促进国际学术交流，广泛开展合作与教育，积极提升人类健康生活水平。':"Dehaa Rossun Research Center is a multi-institutional, multi-disciplinary organization. The main research areas focus on nutrition, pathology, nursing, behaviour, psychology and so on. In view of the health status of modern families, the prospective and predictive research will be conducted to provide comprehensive solutions for family health in various fields. Dehaa Rossun actively promotes international academic exchanges, broadens cooperation and education, and improves healthy living standards of human beings"), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_ctx.show?"愿景":"Vision"), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"成为最具活力的探索和创新平台":"To be the most dynamic exploration and innovation"), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"为健康生活和快乐体验而努力":"platform for healthy life and happy experience"), 1)
            ])
          ]),
          _hoisted_17
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.show?"使命":"Mission"), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"所有不懈努力只为每一个家庭":"All of persistent efforts"), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"在每一个时刻":"only for each family at each moment"), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"尽享精准的个性化关爱":"to enjoy the precise care and the beauty of science"), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.show?"感受科学创新的美好":""), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}